import {defineStore} from "pinia";
import {useCallsStore} from "@/stores/callsStore";
import {useGroupCallsStore} from "@/stores/groupCallsStore";
import {useICPStore} from "@/stores/icpStore";

export const useMediaStore = defineStore('media', {
    state: () => ({
        showValue: 57, defaultValue: 57
    }),

    getters: {

        getVolume: state => {
            return state.volume
        }

    },

    actions: {
        updateVolume(newVolume) {
            if (0 <= newVolume <= 100) {
                this.showValue = newVolume;
                if (useCallsStore().selectedCall[0]) {
                    // individual call selected
                    useCallsStore().setCallVolume(newVolume);
                } else if (useGroupCallsStore().getActiveGroupIsdn) {
                    // group call selected
                    useGroupCallsStore().setGroupVolume(newVolume);
                } else {
                    // align call volume
                    this.defaultValue = newVolume;
                    useICPStore().ICP.dispatch.device.setVolume({
                        "cid": "-1",  // default volume
                        "volume": newVolume.toString(), "callback": () => {
                        }
                    })
                }
            }
        },

        alignShowValue() {
            if (useCallsStore().selectedCall[0]) {
                // individual call selected
                this.showValue = useCallsStore().selectedCall[0].volume;
            } else if (useGroupCallsStore().getActiveGroupIsdn) {
                // group call selected
                this.showValue = useGroupCallsStore().getGroupByIsdn(useGroupCallsStore().getActiveGroupIsdn).volume;
            } else {
                // show default value
                this.showValue = this.defaultValue;
            }
        }
    }
})